import { InterviewState } from "../../../models/states/InterviewState";
import { questionnaireSliceReducer } from "./questionnaireSliceReducer";
import { deviceSliceReducer } from "./deviceSliceReducer";
import { variablesSliceReducer } from "./variablesSliceReducer";
import { respondentSliceReducer } from "./respondentSliceReducer";
import { languageSliceReducer } from "./languageSliceReducer";
import { quotasReducer } from "./quotasReducer";
import { themeSliceReducer } from "./themeSliceReducer";
import { validationSliceReducer } from "./validationSliceReducer";
import { carrouselReducer } from "../carrouselReducer";
import { ActionTypes } from "../../actions/types";
import { CONNECTION_DISCONNECTED, USE_CLIENT_VALIDATION } from "../../actions";
import { navigationReducer } from "./navigationReducer";

export const INITIAL_STATE: InterviewState = {
    variables: {
        system: {},
        mentionsByVariableName: {},
    },
    navigation: {
        history: [],
        randomizedBlocks: [],
        randomizedQuestionIdByName: {},
        randomizedQuestionIdByVariable: {},
        questionIndex: 0,
        loopByBlockName: {},
        disabled: false,
        hasNextPage: false,
        hasPreviousPage: false,
        blockIndex: 0,
    },
    validation: {
        isValid: true,
        errorsByVariableName: {},
    },
    language: "en",
};

export const interviewReducer = (state = INITIAL_STATE, action: ActionTypes): InterviewState => {
    switch (action.type) {
        case CONNECTION_DISCONNECTED:
            return INITIAL_STATE;
        case USE_CLIENT_VALIDATION:
            return {
                ...state,
                useClientValidation: action.useValidation,
            };
        default:
            break;
    }
    const previousPage = state.navigation.currentPage;
    const questionnaire = questionnaireSliceReducer(state.questionnaire, action);
    state = {
        ...state,
        quotas: quotasReducer(state.quotas, state, action),
    };
    const navigation = navigationReducer(state.navigation, action, questionnaire, state);
    const respondent = respondentSliceReducer(state.respondent, action, navigation, previousPage);
    const device = deviceSliceReducer(state.device, action);
    const variables = variablesSliceReducer(
        state.variables,
        action,
        previousPage,
        questionnaire,
        respondent,
        navigation,
    );
    const validation = validationSliceReducer(state.validation, action, questionnaire, variables);
    const language = languageSliceReducer(state.language, action, questionnaire);
    const theme = themeSliceReducer(state.theme, navigation, action, questionnaire);
    const carrousel = carrouselReducer(state.carrousel, action);
    return {
        ...state,
        questionnaire,
        quotas: state.quotas,
        navigation,
        respondent,
        validation,
        device,
        variables,
        language,
        theme,
        carrousel,
    };
};
